import { render, staticRenderFns } from "./GrupoDeAcesso.vue?vue&type=template&id=10e24090&scoped=true&lang=pug&"
import script from "./GrupoDeAcesso.vue?vue&type=script&lang=js&"
export * from "./GrupoDeAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e24090",
  null
  
)

export default component.exports